import { CommonModule } from '@angular/common';
import { IconComponent } from './icon.component';
import { NgModule } from '@angular/core';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
    imports: [CommonModule, NzPopoverModule, NzIconModule],
    declarations: [IconComponent],
    exports: [IconComponent],
})
export class IconModule {}
